import { useId } from "react";
import Icon from "./Icon";

// Tarjeta que se despliega tocando el título, para que el panel no quede tan largo.
const Collapse = ({ title, before, after, open, onToggle, children }) => {

    const id = useId();

  return (
    <section className={open ? "lp-panel-card lp-panel-collapse lp-panel-collapse-open" : "lp-panel-card lp-panel-collapse"}>
        <h2>
            <button type="button" className="lp-panel-collapse-head" aria-expanded={open} aria-controls={id} onClick={onToggle}>
                {before}
                <span className="lp-panel-collapse-title">{title}</span>
                {after}
                <span className="lp-panel-collapse-icon"><Icon name="chevron" size={20}></Icon></span>
            </button>
        </h2>
        {open && <div id={id} className="lp-panel-collapse-body">{children}</div>}
    </section>
  )
}

export default Collapse
